<template>
    <div class="myCheck">
      <cube-scroll
          ref="scroll"
          :data="item"
          :options="options"
          @pulling-down="onPullingDown"
          @pulling-up="onPullingUp" class="page_scroll order-center-top">
        <van-nav-bar
          title="我的检测"
          left-arrow
          @click-left="onClickLeft"
        />
          <div class="noDate" v-if="info.length == 0">
            <p>
              暂时没有数据哦~
            </p>
          </div>
          <div v-for="(item, index) in info" :key="index">
            <router-link :to="{name:'orderDetail',params:{order_id: item.order_id}}">
              <style-list :info='item' :type="type" ></style-list>
            </router-link>
          </div>
      </cube-scroll>
    </div>
</template>
<script>
import styleList from '../views/styleList'
import Vue from 'vue'
import { NavBar } from 'vant'
Vue.use(NavBar)
export default {
  name: 'myCheck',
  data () {
    return {
      type:'check',
      info:[],
      item: [],
      user_id: localStorage.getItem('user_id'),
      options: {
          pullUpLoad: {
            threshold: 60,
            txt: {
              more: '加载更多',
              // noMore: '没有更多了'
            }
          },
          pullDownRefresh: {
            threshold: 60,
            // stop:,
            // stopTime:,
            txt: '刷新成功'
          },
      },
    }
  },
  created () {
    this.loadPage(1,1)
  },
  methods:{

    // 返回
    onClickLeft() {
      this.$router.go(-1)
    },
    loadPage (pageNum, type) {
      let _this = this
      _this.$http.api.myCheck({
        user_id: this.user_id,
        page: pageNum,
        size: 10
      }).then (result => {
        // this.info = [...result.rows]
         _this.allpage = Math.ceil(result.total/10)
        let data = result.rows
        data = result.rows.map(item => {
          let status = []
          if(item.classify == 1){
            // 检测类
            status = ['待付款','已付款', '已寄出工具', '已回寄', '已收样','报告生成', '已寄出报告','已完成']
          }else if( item.classify == 2) {
            // 合成类
            status = ['待付款','已付款', '已寄出工具', '已回寄', '已收样','制作完成', '已寄出成品','已完成']
          }else if(item.classify == 3){
            // 保管类
            status = ['待付款','已付款', '已寄出工具', '已回寄', '已收样','制作完成', '代保管中','已完成']
          }
          return Object.assign({}, item, {    //时间格式化
            order_status: status[item.order_status-1],
          });
        });
        if (type === 1) {
          _this.info = [...data]
          _this.$refs.scroll.forceUpdate()
          _this.pageNum = 2
        } else {
          // console.log(_this.pageNum,_this.allpage)
          if (data.length > 0 && _this.pageNum <= _this.allpage) {
             _this.info = _this.info.concat(data)
            _this.pageNum = _this.pageNum + 1
            setTimeout(function () {
              _this.$refs.scroll.forceUpdate()
            }, 300)
          }else {
            //  console.log(2)
          }
        }
      })
      if( _this.pageNum > _this.allpage){
        setTimeout(function () {
          _this.$refs.scroll.forceUpdate()
        }, 300)
      }
    },
    onPullingDown () {
      // this.isLoading = false
      this.loadPage(1, 1)
    },
    onPullingUp () {
      let _this = this
      // _this.isLoading = false
      setTimeout(function () {
        // console.log(this.isType)
        _this.loadPage(_this.pageNum,2)
      }, 800)
    },
  },
  components: {
    styleList
  }
}
</script>
<style lang="less" scoped>
.page_scroll{
  bottom: 0
}
.noDate {
  width: 100%;
  text-align: center;
  font-size: 14px;
  background: #fff;
  padding-top: 20px;
}
</style>
